import { ArrowLeft, Asterisk } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang, useT } from "@/i18n/LangContext";
import LangSwitch from "./LangSwitch";

export default function Privacy() {
  const t = useT();
  const lang = useLang();
  const homePath = lang === "fi" ? "/fi" : "/";

  return (
    <div className="min-h-screen bg-paper font-sans text-ink antialiased">
      <header className="border-b border-lavline bg-paper">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 px-6 py-5">
          <span className="flex items-baseline gap-2">
            <span className="flex items-center gap-1 font-serif text-xl tracking-tight text-ink">
              Encraft
              <Asterisk className="h-5 w-5 text-bee" aria-hidden="true" />
            </span>
            <span className="text-[0.6rem] font-medium uppercase tracking-[0.3em] text-ink/60">
              Studio
            </span>
          </span>
          <div className="flex items-center gap-6">
            <LangSwitch />
            <Link
              to={homePath}
              data-testid="privacy-back-link"
              className="group flex items-center gap-2 text-sm font-medium text-ink transition-colors duration-300 hover:text-ink/70"
            >
              <ArrowLeft
                className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1"
                aria-hidden="true"
              />
              {t.privacy.back}
            </Link>
          </div>
        </div>
      </header>
      <main id="main" className="mx-auto max-w-3xl px-6 py-20">
        <p className="text-xs font-medium uppercase tracking-[0.25em] text-ink/75">
          {t.privacy.overline}
        </p>
        <h1 className="mt-6 font-serif text-4xl font-light leading-tight tracking-tight text-ink md:text-5xl">
          {t.privacy.title}
        </h1>
        <p className="mt-4 text-sm text-ink/75">{t.privacy.updated}</p>
        <div data-testid="privacy-content">
          {t.privacy.blocks.map((b, i) => (
            <section key={i} className="mt-14">
              <h2 className="font-serif text-2xl font-normal tracking-tight text-ink md:text-3xl">
                {b.h}
              </h2>
              {b.p &&
                b.p.map((para, j) => (
                  <p
                    key={j}
                    className="mt-5 text-base font-light leading-relaxed text-ink/85"
                  >
                    {para}
                  </p>
                ))}
              {b.table && (
                <div className="mt-6 overflow-x-auto">
                  <table className="w-full border-collapse text-sm">
                    <thead>
                      <tr>
                        {b.table.head.map((h) => (
                          <th
                            key={h}
                            scope="col"
                            className="border border-lavline bg-lav px-4 py-3 text-left font-medium text-ink"
                          >
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {b.table.rows.map((r, k) => (
                        <tr key={k}>
                          {r.map((c, m) => (
                            <td
                              key={m}
                              className="border border-lavline px-4 py-3 align-top font-light leading-relaxed text-ink/85"
                            >
                              {c}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {b.after &&
                b.after.map((para, j) => (
                  <p
                    key={j}
                    className="mt-5 text-base font-light leading-relaxed text-ink/85"
                  >
                    {para}
                  </p>
                ))}
              {b.lines && (
                <p className="mt-5 text-base font-light leading-relaxed text-ink/85">
                  {b.lines.map((line, j) => (
                    <span key={j}>
                      {line}
                      {j < b.lines.length - 1 && <br />}
                    </span>
                  ))}
                </p>
              )}
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
